const SITE = "IndiaFees";
const SITE_URL = "https://www.indiafees.com";
const OG_IMAGE = `${SITE_URL}/og-share.svg`;
const DEFAULT_DESC =
  "IndiaFees — official Tamil Nadu government payment links. Electricity, tax, water, fees & challans. Directory only — we never collect money.";

function setMeta(attr, key, value) {
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

function setLink(rel, href) {
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export function updatePageMeta({ title, description = DEFAULT_DESC, path = "/" }) {
  const fullTitle = title ? `${title} — ${SITE}` : `${SITE} — Tamil Nadu Government Payments`;
  const url = `${SITE_URL}${path}`;
  document.title = fullTitle;
  setMeta("name", "description", description);
  setLink("canonical", url);
  setMeta("property", "og:title", fullTitle);
  setMeta("property", "og:description", description);
  setMeta("property", "og:url", url);
  setMeta("property", "og:image", OG_IMAGE);
  setMeta("name", "twitter:title", fullTitle);
  setMeta("name", "twitter:description", description);
  setMeta("name", "twitter:image", OG_IMAGE);
}
